export const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj?.[k] != null) return obj[k];
  }
  return undefined;
};

export const toNumber = (v) => {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const getLawFlag = (law, index) => {
  if (!law || law.length <= index) return 1;
  const n = Number(law[index]);
  return Number.isFinite(n) ? n : 1;
};

/** Delphi TColor (int) → #RRGGBB */
export const colorIntToHex = (value) => {
  const n = toNumber(value);
  if (n == null) return "#000000";
  return `#${(n >>> 0).toString(16).padStart(6, "0").slice(-6)}`;
};

/** #RRGGBB / ColorPicker value → int */
export const colorHexToInt = (value) => {
  if (value == null || value === "") return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value >>> 0;
  let hex = String(value);
  if (typeof value === "object" && value?.toHexString) {
    hex = value.toHexString();
  } else if (typeof value === "object" && value?.metaColor) {
    hex = value.toHexString?.() || "#000000";
  }
  const m = String(hex).trim().replace(/^#/, "").match(/^([0-9a-fA-F]{6})/);
  if (!m) return 0;
  return Number.parseInt(m[1], 16) >>> 0;
};

export const colorSwatch = (value) => {
  const hex = colorIntToHex(value);
  return {
    hex,
    style: {
      display: "inline-block",
      width: 14,
      height: 14,
      borderRadius: 2,
      background: hex,
      border: "1px solid rgba(0,0,0,0.2)",
      verticalAlign: "middle"
    }
  };
};

export const normalizeStatus = (row) => ({
  idStatus: toNumber(pick(row, "idStatus", "IdStatus")),
  idx: toNumber(pick(row, "idx", "Idx")) ?? 0,
  name: pick(row, "name", "Name") ?? "",
  color: toNumber(pick(row, "color", "Color")) ?? 0
});

export const emptyStatus = () => ({
  idStatus: null,
  idx: 0,
  name: "",
  color: 0
});
